<div class="auth-wrapper">
  @if (configLoading) {
    <div class="auth-loading" role="status" aria-live="polite">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else {
  <mat-card class="auth-card" appearance="outlined">
    <mat-card-content class="auth-content">
      <h1 class="headline">{{ 'signup.headline' | transloco }}</h1>

      @if (submitted) {
        <p class="confirmation">{{ 'signup.confirmation' | transloco }}</p>
        <div class="login-link">
          <a [routerLink]="['/']" queryParamsHandling="preserve">{{ 'common.backToSignIn' | transloco }}</a>
        </div>
      } @else {
      <p class="supporting">{{ 'signup.supporting' | transloco }}</p>

      <form [formGroup]="signupForm" (ngSubmit)="submit()" novalidate>
        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <mat-label>{{ 'common.form.emailLabel' | transloco }}</mat-label>
          <input matInput type="email" formControlName="email" maxlength="254" autocomplete="email"/>
          @if (signupForm.get('email')?.hasError('required') && signupForm.get('email')?.touched) {
            <mat-error>{{ 'common.errors.emailRequired' | transloco }}</mat-error>
          }
          @if (signupForm.get('email')?.hasError('email') && signupForm.get('email')?.touched) {
            <mat-error>{{ 'common.errors.emailInvalid' | transloco }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" subscriptSizing="dynamic">
          <mat-label>{{ 'common.form.passwordLabel' | transloco }}</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'"
                 formControlName="password" autocomplete="new-password"/>
          <button mat-icon-button matSuffix type="button"
                  (click)="hidePassword = !hidePassword"
                  [attr.aria-label]="(hidePassword ? 'common.form.showPassword' : 'common.form.hidePassword') | transloco">
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          @if (signupForm.get('password')?.hasError('required') && signupForm.get('password')?.touched) {
            <mat-error>{{ 'common.errors.passwordRequired' | transloco }}</mat-error>
          }
          @if (signupForm.get('password')?.hasError('minlength') && signupForm.get('password')?.touched) {
            <mat-error>{{ 'common.errors.passwordTooShort' | transloco }}</mat-error>
          }
        </mat-form-field>

        @if (termsLoading) {
          <div class="terms-loading" role="status" aria-live="polite">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
        }
        @if (termsLoadError) {
          <p class="error" role="alert">{{ 'signup.terms.loadError' | transloco }}</p>
        }
        @if (!termsLoading && !termsLoadError && eligibleTerms.length > 0) {
          <div class="terms-list">
            @for (term of eligibleTerms; track term.id) {
              <div class="term-row">
                <mat-checkbox
                  [checked]="isTermAccepted(term.id)"
                  (change)="toggleTerm(term.id, $event.checked)">
                  {{ term.resume }}
                  @if (term.kind === 'permission') {
                    <span class="term-optional">&nbsp;({{ 'signup.terms.optional' | transloco }})</span>
                  }
                </mat-checkbox>
                <button mat-button type="button" class="term-read-more"
                        (click)="openFullText(term)">
                  {{ 'signup.terms.readFullText' | transloco }}
                </button>
              </div>
            }
          </div>
        }

        @if (error) {
          <p class="error" role="alert">{{ error }}</p>
        }

        <button mat-flat-button color="primary" type="submit"
                [attr.aria-busy]="captchaSolving ? 'true' : null"
                [disabled]="signupForm.invalid || loading || termsLoading || termsLoadError || hasUnacceptedMandatoryTerm">
          @if (loading) {
            {{ 'signup.submit.loading' | transloco }}
          } @else {
            {{ 'signup.submit.idle' | transloco }}
          }
        </button>
        <p class="visually-hidden" role="status" aria-live="polite">{{ captchaSolving ? ('common.captcha.verifying' | transloco) : '' }}</p>

        <div class="login-link">
          {{ 'signup.alreadyHaveAccount' | transloco }} <a [routerLink]="['/']" queryParamsHandling="preserve">{{ 'common.signInLink' | transloco }}</a>
        </div>
      </form>
      }
    </mat-card-content>
  </mat-card>
  }
</div>
